import React from 'react'
import _ from 'lodash'
import {
  Col,
  FormInputCheckbox,
  Row
} from 'camino-react'

const MultiSelectType = ({
  question,
  handleMultiSelect,
  unsubmittedResponses
}) => {
  const getCurrentMultiSelectValue = (questionId, answer) => {
    const foundQuestion = _.find(unsubmittedResponses, { questionId: questionId })

    if (_.isNil(foundQuestion)) {
      return false
    } else {
      const foundAnswer = foundQuestion.answer[answer]

      return _.isNil(foundAnswer) ? false : true
    }
  }

  return (
    <Row>
      <Col>
        {_.map(question.answers, (answer, index) => (
          <FormInputCheckbox
            key={index}
            onValue={value => handleMultiSelect(value, question, answer)}
            value={getCurrentMultiSelectValue(question.id, answer)}
            id={`multiselect_answers_${question.id}_${index}`}
          >
            {answer}
          </FormInputCheckbox>
        ))}
      </Col>
    </Row>
  )
}

export default MultiSelectType
